import { useEffect, useState } from "react";
import MaterialIcon from "@common/components/MaterialIcon";
import { coverFor } from "./covers";

/** A game's box art; a placeholder of the same shape while it loads or when there is none. */
export default function Cover({ name, className }: { name: string; className: string }) {
  const [found, setFound] = useState<{ name: string; src: string | null } | null>(null);
  useEffect(() => {
    let live = true;
    coverFor(name).then((url) => live && setFound({ name, src: url }));
    return () => {
      live = false;
    };
  }, [name]);
  // undefined while looking it up, null when there is none.
  const src = found?.name === name ? found.src : undefined;
  if (src) return <img src={src} alt="" className={className} loading="lazy" onError={() => setFound({ name, src: null })} />;
  return (
    <span className={`${className} cover-blank`} aria-hidden="true">
      {src === null && <MaterialIcon name="videogame_asset" />}
    </span>
  );
}
